import {
    importLibrary,
    setOptions
} from "@googlemaps/js-api-loader";

const GOOGLE_MAPS_API_KEY =
    import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

let librariesPromise = null;

export const loadGoogleMapsLibraries = async () => {
    if (!GOOGLE_MAPS_API_KEY) {
        throw new Error(
            "KEY is not configured."
        );
    }

    if (!librariesPromise) {
        setOptions({
            key: GOOGLE_MAPS_API_KEY,
            v: "weekly"
        });

        librariesPromise = Promise.all([
            importLibrary("maps"),
            importLibrary("marker"),
            importLibrary("places")
        ]);
    }

    return librariesPromise;
};

export const loadGoogleMaps = async () => {
    return loadGoogleMapsLibraries();
};